import { render, staticRenderFns } from "./noDataTip.vue?vue&type=template&id=54dc8190&scoped=true&"
import script from "./noDataTip.vue?vue&type=script&lang=js&"
export * from "./noDataTip.vue?vue&type=script&lang=js&"
import style0 from "./noDataTip.vue?vue&type=style&index=0&id=54dc8190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc8190",
  null
  
)

export default component.exports